import CertificateElement from "./certificateElement";
import store from "../../../common/state/store";
import {RelationType} from "../../../common/models/relationType";
import {ObjectHelper} from "../../../common/helpers/objectHelper";
import IRepo from "../../../common/interfaces/repo";
import Repo from "../../../common/state/modules/repo";
import Organization from "../../../common/models/organization";
import Shareable from "../../../common/mixins/shareable";
import Capable from "../../../common/mixins/capable";
import Validatable from "../../../common/mixins/validatable";
import CertificateBuilderModel from "../../../common/models/tracked/certificateBuilderModel";
import DimensionHandler from "../../../common/mixins/dimensionHandler";
import IRootBuilderModel from "../../../common/interfaces/builderModelInterfaces";
import {INavigableValidatableModel} from "../../../common/interfaces/navigableValidationInterfaces";
import {ICapable} from "../../../common/interfaces/capableInterfaces";
import CertificateBuilderValidation from "../../../common/models/navigableValidations/certificateBuilderValidation";
import {AttributeMetadataInterface} from "../../../common/interfaces/attributeMetadataInterface";
import Share from "../../../common/models/share";
import CertificateDynamicInput from "./certificateDynamicInput";
import CertificateDynamicInputFactory from "./certificateDynamicInputFactory";
import CertificateMapping from "./certificateMapping";
import CertificateMappingFactory from "./certificateMappingFactory";
import ErrorHandler from "~/models/errorHandling/errorHandler";
import {CertificateSize} from "../enums/certificateSize";
import {CertificateOrientation} from "../enums/certificateOrientation";
import PageCertificateElement from "./pageCertificateElement";
import Vue from "vue";
import {CertificateFormat} from "../enums/certificateFormat";
import {Hash} from "~/interfaces/hashInterfaces";
import CertificateDynamicInputContainer from "./certificateDynamicInputContainer";
import CertificateFoundationLayer from "./certificateFoundationLayer";
import CertificateFoundationLayerFactory from "./certificateFoundationLayerFactory";
import {CertificateType} from "~/enums/certificates/certificateType";
import Selected from "../store/modules/selected";
import CertificateElementable from "../certificateElementable";
import CertificateElementHandler from "~/services/certificateElementHandler";
import {certificateElementType} from "~/enums/certificateElementType";
import TextCertificateElement from "./textCertificateElement";
import ImageCertificateElement from "./imageCertificateElement";
import DynamicImageCertificateElement from "./dynamicImageCertificateElement";
import DynamicListCertificateElement from "./dynamicListCertificateElement";
import GridCertificateElement from "./gridCertificateElement";
import GridCellCertificateElement from "./gridCellCertificateElement";
import StackCertificateElement from "./stackCertificateElement";
import DynamicModeTextCertificateElement from "./dynamicModeTextCertificateElement";
import DynamicModeImageCertificateElement from "./dynamicModeImageCertificateElement";
import DynamicModeDynamicImageCertificateElement from "./dynamicModeDynamicImageCertificateElement";
import DynamicModeDynamicListCertificateElement from "./dynamicModeDynamicListCertificateElement";
import DividerCertificateElement from "./dividerCertificateElement";
import DynamicModeCertificateElement from "./dynamicCertificateElement";
import BaseCertificateElement from "./baseCertificateElement";
import {CertificateDownloadFormat} from "../enums/certificateDownloadFormat";
import {DocumentType} from "~/enums/documentType";
import AdaptiveLayoutSection from "./adaptiveLayoutSection";
import AdaptiveLayoutSectionHandler from "~/services/adaptiveLayoutSectionHandler";
import PageBreakCertificateElement from "./pageBreakCertificateElement";
import * as _ from 'lodash'
import DynamicSignatureCertificateElement from "./dynamicSignatureCertificateElement";
import DynamicModeDynamicSignatureCertificateElement from "./dynamicModeDynamicSignatureCertificateElement";
import {ModelType} from "~/enums/modelType";
import {IImposter, IImposterOptions} from "~/interfaces/imposterInterfaces";
import Imposter from "~/models/imposter";
import {GenericType} from "~/interfaces/genericTypeInterfaces";

export type TCertificate = Certificate;

export default class Certificate extends CertificateDynamicInputContainer(CertificateElementable(Shareable(Capable(Validatable(CertificateBuilderModel))))) implements IRootBuilderModel, INavigableValidatableModel<Certificate>, ICapable {
  type: CertificateType;
  organization: Organization;
  attributes_metadata: { [key: string]: AttributeMetadataInterface };
  except = ['shares'];
  certificate_file_uploads;
  _hasChanged: boolean = false;
  u_at_moment;
  lastSavedMessage: string;
  title: string;
  size: CertificateSize;
  format: CertificateFormat;
  download_format: CertificateDownloadFormat;
  orientation: CertificateOrientation;
  margin: number;
  certificate_mappings: Hash<CertificateMapping> = {};
  certificate_foundation_layers: Hash<CertificateFoundationLayer> = {};
  adaptive_layout_sections: Hash<AdaptiveLayoutSection> = {};
  foundation_layer_dependents: { id: string, title: string }[];
  _certificateElementHandler = new CertificateElementHandler(this, Certificate, 'certificate_elements');
  certificate_dynamic_inputs: { [key: string]: CertificateDynamicInput } = {};
  attempted_to_publish: boolean;
  certificate_id?: string;
  _adaptiveLayoutSectionHandler = new AdaptiveLayoutSectionHandler(this, Certificate, 'adaptive_layout_sections');
  _is_in_download_mode: boolean = false;
  _is_in_download_debug_mode: boolean = false
  _data_mapping: any;
  _is_in_foundation_layer_generation_mode: false
  get data_mapping(){
    return this._data_mapping
  }

  checkIsValidUpstreamData(scopedData, data_mapping = this.data_mapping) : boolean{
    if (_.isEqual(data_mapping, scopedData )) return true
    return Object.keys(data_mapping).some(key=>{
      if (!(data_mapping[key] instanceof Array)){
        return false
      }else{
        return data_mapping[key].some(dataNode => this.checkIsValidUpstreamData(scopedData, dataNode))
      }
    })
  }

  validUpstreamValues(scopedData, data_mapping = this.data_mapping, valuesObj = {}) {
    if (this.checkIsValidUpstreamData(scopedData, data_mapping)) {
      Object.keys(data_mapping).some(key => {
        if (!(data_mapping[key] instanceof Array)) {
          valuesObj[key] = data_mapping[key]
        } else {
          data_mapping[key].forEach(dataNode => this.validUpstreamValues(scopedData, dataNode, valuesObj))
        }
      })
    }
    return valuesObj
  }
  get is_in_foundation_layer_generation_mode(): boolean{
    return this._is_in_foundation_layer_generation_mode
  }

  get longestSectionWidthInPixels() : number{
    return Math.max.apply(Math, this.adaptiveLayoutSectionsArray.map(x=> x.dimensions.width));
  }

  getMappedDataValue(input_client_id: string, repeatable_index: number = null, sub_input_client_id: string = null) {
    const dynamic_input = this.findCertificateDynamicInput(input_client_id)
    if (!dynamic_input) {
      return ""
    }
    let parent_mapping
    const dynamic_input_parent = dynamic_input.parent
    if (dynamic_input_parent instanceof CertificateDynamicInput) {
      parent_mapping = this.data_mapping[dynamic_input_parent.client_id]
    } else {
      parent_mapping = this.data_mapping
    }
    if (Array.isArray(parent_mapping) && (!!dynamic_input_parent || dynamic_input_parent === 0)) {
      parent_mapping = parent_mapping[repeatable_index]
    }
    if (!!sub_input_client_id) {
      return parent_mapping[dynamic_input.client_id].map(x => x[sub_input_client_id])

    } else {
      return parent_mapping[dynamic_input.client_id]
    }
  }


  static get $builderCanvasContainer() : JQuery{
    return $(".canvas-container");
  }

  get is_in_download_mode(): boolean{
    return this._is_in_download_mode
  }

  get is_in_download_debug_mode(): boolean{
    return this._is_in_download_debug_mode
  }

  // ******************** VERSIONABLE begin ******************** //

  get adaptiveLayoutSectionHandler(): AdaptiveLayoutSectionHandler {
    return this._adaptiveLayoutSectionHandler;
  }

  get marginInPixels(): number {
    return (this.margin * 96)
  }

  get currentSection(): CertificateElement {
    return this.selectedElementsSection || this.adaptiveLayoutSectionsArray[0]
  }

  // *****************  Selector concerns *******************//
  get selectedCertificateElement(): BaseCertificateElement {
    return this.selector.get();
  }

  get currentPage(): CertificateElement {
    return Selected.currentPage.get()
  }

  get selector() {
    return Selected.certificateElement;
  }

  get selectedElementsSection() {
    return (this.selectedCertificateElement as DynamicModeCertificateElement)?.section
  }

  get selectedElementsLayoutElement() {
    return (this.selectedCertificateElement as DynamicModeCertificateElement)?.layoutElementContainer
  }

  //For adding Dynamic Mode Elements
  get parentForInsertElement() {
    if (this.isDynamicLayout) {
      return this.firstSelectedOrEmptyContainerElement?.firstEmptyCell || this.firstSelectedOrEmptyContainerElement
    } else {
      return this.currentPage
    }
  }

  //For adding Dynamic Mode Elements
  get firstSelectedOrEmptyContainerElement() {
    return this.selectedElementsLayoutElement || (this.currentSection.certificateElementsArray[this.currentSection.certificateElementsArray.length - 1] as DynamicModeCertificateElement )?.layoutElementContainer
  }

  get isDynamicLayout() {
    return this.type === CertificateType.Dynamic
  }

  get isPdfDownloadFormat() {
    return this.download_format === CertificateDownloadFormat.WebPDF || this.download_format === CertificateDownloadFormat.PrintPDF
  }

  get displayName() {
    return 'Certificate';
  }

  get collectionKey() {
    return 'certificates';
  }

  get classKey(): string {
    return "certificate";
  }

  get docType(): DocumentType {
    return DocumentType.certificate;
  }

  get rootName(): string {
    return Certificate.rootName
  }

  get referenceNameOrDefault(): string {
    return this.title;
  }

  static get displayName(): string {
    return 'Certificate';
  }

  static get rootName(): string {
    return 'certificate';
  }

  static get cardScale(): number {
    return 3
  }

  get stageBounds(): { width: number, height: number } {
    let x, y, width, height;
    const pages = this.pageElements;
    const lastPage: PageCertificateElement = pages[pages.length - 1];
    x = lastPage.pageBounds[1].x;
    y = lastPage.pageBounds[1].y;
    // adds additional padding
    width = x + (3 * Certificate.initialOffset);
    height = y + (3 * Certificate.initialOffset);
    return {height, width};
  }

  // ******************** VERSIONABLE end ******************** //

  //******************** VALIDATABLE BEGIN ********************//
  _validation: CertificateBuilderValidation = new CertificateBuilderValidation(this);

  updatePageSortOrder(newSortOrderArray) {
    this.pageElements.forEach(page => {
      let oldSortOrder = page.sort_order
      let newSortOrder = newSortOrderArray.indexOf(page.client_id)
      let pageShiftDirection: "up" | "down" = newSortOrder < oldSortOrder ? "up" : "down"
      let pageShift = Math.abs(oldSortOrder - newSortOrder)
      page.sort_order = newSortOrder
      for (let i = 0; i < pageShift; i++) {
        PageCertificateElement.shiftPageElements(page, pageShiftDirection)
      }
    })
  }

  getDisplayName(propName: string, value?): string {
    switch (propName) {
      case 'foundation_layer_dependents':
        return 'Foundation Layer Dependents';
      default:
        return this.attributes_metadata[propName].display_name;
    }
  }

  //******************** VALIDATABLE END ********************//

  public static dimensions: object = {
    letter: {
      inches: {
        short: 8.5,
        long: 11
      },
      pixels: (pixelsPer = DimensionHandler.defaultPixelsPer, scale = 1) => {
        return DimensionHandler.convertToPixels(Certificate.dimensions['letter'].inches, pixelsPer, scale)
      }
    },
    cr80: {
      inches: {
        short: 2.125,
        long: 3.375
      },
      pixels: (pixelsPer = DimensionHandler.defaultPixelsPer, scale = 1) => {
        return DimensionHandler.convertToPixels(Certificate.dimensions['cr80'].inches, pixelsPer, scale)
      }
    },
  };

  static get initialOffset(): number {
    return 20;
  }

  static get pageMargin(): number {
    return 50;
  }

  static get canvasXMargin(): number {
    return 50;
  }

  static get tabHeight(): number {
    return 30;
  }

  static get letterPixelDimensions() {
    return Certificate.dimensions['letter'].pixels()
  }

  static get cardPixelDimensions() {
    return Certificate.dimensions['cr80'].pixels()
  }

  static repo: IRepo<Certificate> = new Repo<Certificate>('certificates', Certificate);

  createEmbeddedObject = {
    certificate_dynamic_inputs: (parent, json): CertificateDynamicInput => {
      return CertificateDynamicInputFactory.create(this, json, false);
    },
    certificate_elements: (parent, json): CertificateElement => {
      return Certificate.certificateElementFactory(json["type"])
    },
    certificate_mappings: (parent, json): CertificateMapping => {
      return CertificateMappingFactory.create(this, json);
    },
    certificate_foundation_layers: (parent, json): CertificateFoundationLayer => {
      return CertificateFoundationLayerFactory.create(this, json);
    },
    adaptive_layout_sections: (parent, json): AdaptiveLayoutSection => {
      return new AdaptiveLayoutSection()
    }
  };

  static certificateElementFactory(elementType: certificateElementType): CertificateElement {
    let element;
    switch (elementType) {
      case certificateElementType.Text:
        element = new TextCertificateElement();
        break;
      case certificateElementType.Image:
        element = new ImageCertificateElement();
        break;
      case certificateElementType.DynamicImage:
        element = new DynamicImageCertificateElement();
        break;
      case certificateElementType.Page:
        element = new PageCertificateElement();
        break;
      case certificateElementType.DynamicList:
        element = new DynamicListCertificateElement();
        break;
      case certificateElementType.Grid:
        element = new GridCertificateElement();
        break;
      case certificateElementType.Stack:
        element = new StackCertificateElement();
        break;
      case certificateElementType.DynamicModeText:
        element = new DynamicModeTextCertificateElement()
        break;
      case certificateElementType.GridCell:
        element = new GridCellCertificateElement();
        break;
      case certificateElementType.DynamicModeImage:
        element = new DynamicModeImageCertificateElement();
        break;
      case certificateElementType.DynamicModeDynamicImage:
        element = new DynamicModeDynamicImageCertificateElement();
        break;
      case certificateElementType.DynamicModeDynamicList:
        element = new DynamicModeDynamicListCertificateElement();
        break;
      case certificateElementType.Divider:
        element = new DividerCertificateElement();
        break;
      case certificateElementType.PageBreak:
        element = new PageBreakCertificateElement()
        break;
      case certificateElementType.DynamicSignature:
        element = new DynamicSignatureCertificateElement();
        break;
      case certificateElementType.DynamicModeDynamicSignature:
        element = new DynamicModeDynamicSignatureCertificateElement();
        break;
    }
    return element
  }

  get EMBEDDED_MODELS(): { [p: string]: { type: any; relationType: RelationType } } {
    return {
      'certificate_elements': {type: CertificateElement, relationType: RelationType.dictionary},
      'shares': {type: Share, relationType: RelationType.collection},
      'certificate_dynamic_inputs': {type: CertificateDynamicInput, relationType: RelationType.dictionary},
      'certificate_mappings': {type: CertificateMapping, relationType: RelationType.dictionary},
      'certificate_foundation_layers': {type: CertificateFoundationLayer, relationType: RelationType.dictionary},
      'adaptive_layout_sections': {type: AdaptiveLayoutSection, relationType: RelationType.dictionary}
    };
  }

  get adaptiveLayoutSectionsArray() {
    return ObjectHelper.toArray(this.adaptive_layout_sections).sort((a, b) => a.sort_order - b.sort_order);
  }

  get certificateElementsArrayDeep() {
    const elements = []
    this.topLevelContainerElements.forEach(page => {
      elements.push(page);
      elements.push(...page.certificateElementsArrayDeep);
    })
    return elements
  }

  findElement(client_id: string) {
    return this.certificateElementsArrayDeep.find(x => x.client_id === client_id)
  }

  get canAddInsertElements(): boolean {
    return this.certificateElementsArrayDeep.some(ce => ce.type === certificateElementType.Grid || ce.type === certificateElementType.Stack)
  }

  get topLevelContainerElements(): AdaptiveLayoutSection[] | PageCertificateElement[] {
    if (this.isDynamicLayout) {
      return this.adaptiveLayoutSectionsArray
    } else {
      return this.pageElements
    }
  }

  get pageElements(): PageCertificateElement[] {
    const pages: PageCertificateElement[] = []
    this.certificateElementsArray.forEach(page => {
      if (page instanceof PageCertificateElement) {
        pages.push(page)
      }
    })
    return pages.sort((a, b) => a.sort_order > b.sort_order ? 1 : -1);
  }

  get orderedCertificateElements() {
    return ObjectHelper.toArray(this.certificate_elements).sort((a, b) => a.sort_order > b.sort_order ? 1 : -1);
  }

  get certificateMappings() {
    return ObjectHelper.toArray(this.certificate_mappings);
  }

  get foundationLayers() {
    return ObjectHelper.toArray(this.certificate_foundation_layers);
  }

  get certificateElementsAndFoundationLayerElements(): CertificateElement[] {
    return [...this.certificateElementsArrayDeep, ...this.foundationLayerElements];
  }

  get foundationLayerSourceDocuments(): Certificate[] {
    return this.foundationLayers
      .map(layer => Certificate.repo.findWhere(certificate => (certificate.certificate_id || certificate.id) === layer.source_document)[0])
      .filter(sourceDoc => !!sourceDoc && !!sourceDoc.id);
  }

  moveElementToPage(element, newIndex) {
    const oldPage = element.parent;
    const oldIndex = oldPage.pageIndex;
    const newPage = this.pageElements[newIndex];
    if (oldIndex === newIndex || !newPage) {
      return
    }
    oldPage.trackCreationDeletion(element.client_id, element.asJson(), null, element);
    Vue.delete(oldPage.certificate_elements, element.client_id);
    newPage.trackCreationDeletion(element.client_id, null, element.asJson(), element);
    Vue.set(newPage.certificate_elements, element.client_id, element);
    element.parent = newPage;
    element.sort_order = newPage.certificateElementsArray.length;
  }

  realignFirstPageElements(direction: 'up' | 'down'): void {
    const firstPage = this.pageElements[0];
    const tabHeight = Certificate.tabHeight;
    if (direction === 'up') {
      for (const element of firstPage.certificateElementsArray) {
        element.y -= tabHeight;
      }
    } else if (direction === 'down') {
      for (const element of firstPage.certificateElementsArray) {
        element.y += tabHeight;
      }
    }
  }

  deletePage(pageElement: PageCertificateElement) {
    const deletedPageIndex = pageElement.pageIndex;
    const willHaveOnePage = this.pageElements.length === 2;

    const pageElementsToShiftUp = this.pageElements.filter(page => page.pageIndex > deletedPageIndex);
    pageElementsToShiftUp.forEach(page => {
      PageCertificateElement.shiftPageElements(page, "up")
    });

    this.trackCreationDeletion(pageElement.client_id, pageElement.asJson(), null, pageElement);
    Vue.delete(this.certificate_elements, pageElement.client_id);
    //Shift elements on pages below deleted page up so keep the same relative position

    this.recalculatePagePositions();
    if (willHaveOnePage && this.size !== CertificateSize.Card) {
      this.realignFirstPageElements('up');
    }
  }


  recalculatePagePositions() {
    this.pageElements
      .sort((a, b) => a.sort_order - b.sort_order)
      .forEach((element, i) => {
        element.sort_order = i;
      });
  }

  //JSPDF Library expects dimensions as [short, long]
  get printDimensions() {
    let dimensions = {}
    if (this.size === CertificateSize.Card) {
      dimensions["short"] = Certificate.cardPixelDimensions.short;
      dimensions["long"] = Certificate.cardPixelDimensions.long;
      //Foldover puts 2 certificates on one page
      if (this.format === CertificateFormat.FoldOver) {
        dimensions["short"] *= 2
      }
    } else {
      dimensions["short"] = Certificate.letterPixelDimensions.short;
      dimensions["long"] = Certificate.letterPixelDimensions.long;
    }
    return dimensions
  }

  highlightPages(): void {
    for (const page of this.pageElements) {
      page.highlightPage();
    }
  }

  unHighlightPages(): void {
    for (const page of this.pageElements) {
      page.unHighlightPage();
    }
  }

  get hasFoundationLayerDependents(): boolean {
    return this.foundation_layer_dependents.length > 0;
  }

  // ******************** TRACK CHANGES******************** //

  get UNTRACKED_PROPERTIES(): string[] {
    return [
      '_snapshots',
      'snapshots',
      'is_published',
      'u_at',
      'attributes_metadata',
      'request'
    ];
  }

  get hasChanged() {
    return this._hasChanged;
  }

  set hasChanged(newVal: boolean) {
    if (newVal) {
      this.queueSendChangesToServer();
    }
    this._hasChanged = newVal;
  }

  saveToServer(): Promise<any> {
    return store.dispatch('certificateStore/saveToServer').then(res => {
      this.handleErrorsAndUpdateSaveMessage(res.better_errors)
    }).catch(err => {
      ErrorHandler.autosaveCatch(this, err);
    });
  }

  protected saveChanges(changes: any, builderArea: any): void {
    store.commit('certificateStore/saveChanges', {changes: changes, area: builderArea});
  }

  get foundationLayerShell() {
    return store.state.certificateStore.foundationLayerShell;
  }

  get shellLayerElements() {
    return store.state.certificateStore.shellLayerElements;
  }

  get foundationLayerElements(): CertificateElement[] {
    return store.state.certificateStore.foundationLayerElements;

  }
  // ******************** TRACK CHANGES END ******************** //

  get isPublishedCertificate(): boolean {
    return !!this.certificate_id;
  }

  get modelType(): ModelType {
    return ModelType.Certificate;
  }
  get model_type(): ModelType {
    return this.modelType;
  }

  get genericType(): GenericType {
    return ModelType.Object;
  }

  imposterFor({modelType, options}: { modelType: ModelType; options?: IImposterOptions }): IImposter {
    return new Imposter({
      ...ObjectHelper.sliceProperties(this, 'id', 'genericType', 'modelType'),
      isCollection: o => o.isCollection,
    }, options)
  }

}

